export default __webpack_public_path__ + "51bd6807367d84c578c05c2f975d6b26.svg";